import Util from '../../lib/utils';
import Vue from 'vue';
import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import VoucherBagOrder from '../entities/voucherbagorder';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import Vuex from 'vuex';
Vue.use(Vuex);

interface VoucherBagOrderState extends ListState<VoucherBagOrder> {
    editVoucherBagOrder: VoucherBagOrder;
    paynum:number;
    orderno:string;
}
class VoucherBagOrderModule extends ListModule<VoucherBagOrderState, any, VoucherBagOrder> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<VoucherBagOrder>(),
        loading: false,
    };
    public actions = {
        async getPagedOrders(context: ActionContext<VoucherBagOrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/VoucherBagOrder/GetPagedOrders', { params: payload.data });
            return reponse.data.result;
        },
        async getOrderDetail(context: ActionContext<VoucherBagOrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/VoucherBagOrder/GetOrderDetail', { params: payload.data });
            return reponse.data.result;
        },
        async getConfirmVoucherBagOrder(context: ActionContext<VoucherBagOrderState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/VoucherBagOrder/GetConfirmVoucherBagOrder',  { params: payload.data });
            return reponse.data.result;
        },
        async addVoucherBagOrder(context: ActionContext<VoucherBagOrderState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/VoucherBagOrder/AddVoucherBagOrder', payload.data);
            return reponse.data.result;
        },
        async deleteOrder(context: ActionContext<VoucherBagOrderState, any>, payload: any) {
            const reponse = await Ajax.delete('/api/services/app/VoucherBagOrder/DeleteVoucherBagOrder?orderno=' + payload.data.orderno);
            return reponse.data.result;
        },

    };
    public mutations = {
        setCurrentPage(state: VoucherBagOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: VoucherBagOrderState, pagesize: number) {
            state.pageSize = pagesize;
        },
        // tslint:disable-next-line:no-shadowed-variable
        edit(state: VoucherBagOrderState, VoucherBagOrder: VoucherBagOrder) {
            state.editVoucherBagOrder = VoucherBagOrder;
        },
        updatePaynum(state: VoucherBagOrderState, num: number) {
            state.paynum = num;
        },
        updateVoucherBagOrderno(state: VoucherBagOrderState, orderno: string) {
            state.orderno = orderno;
        },
    };
}
const voucherBagOrderModule = new VoucherBagOrderModule();
export default voucherBagOrderModule;
